import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    name: String
  }

  connect() {
    if (!this.#cookieExists())
      this.#open()
  }

  #open() {
    this.#toggle(true)
  }

  close(event) {
    this.#setCookie()
    this.#toggle(false)
  }

  #toggle(state) {
    this.element.toggleAttribute('hidden', !state)
  }

  redirect(event) {
    this.#setCookie()
    Turbo.visit(event.params.url)
  }

  #setCookie() {
    const expiry = new Date()
    expiry.setTime(expiry.getTime() + (365 * 24 * 3600 * 1000))
    document.cookie = `${this.nameValue}=1; expires=${expiry.toUTCString()}; path=/`
  }

  #cookieExists() {
    const cookies = Object.fromEntries(document.cookie.split('; ').map(v=>v.split(/=(.*)/s).map(decodeURIComponent)))
    return cookies[this.nameValue] ? true : false
  }
}
